import React from "react";
import { Box, Grid, Typography, Avatar } from "@mui/material";
import { styled } from "@mui/system";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const steps = [
    {
        id: 1,
        title: "Üye Ol",
        description: "Ardventure’ye üye olarak projeleri keşfetmenin ilk adımını at.",
        icon: <PersonAddAltIcon />,
    },
    {
        id: 2,
        title: "Projeyi İncele",
        description: "Geleceğin büyük proje fikirlerini incele.",
        icon: <AccountBalanceIcon />,
    },
    {
        id: 3,
        title: "Yatırımcı Ol",
        description: "Yüksek getiri potansiyeli içeren girişimlere yatırım yap.",
        icon: <TrendingUpIcon />,
    },
];

const StepContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 4),
    borderRadius: theme.spacing(2),
}));

const StepCard = styled(Box)(({ theme }) => ({
    textAlign: "center",
    padding: theme.spacing(4),
    maxWidth: 350,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-8px)',
    }
}));

const StepIcon = styled(Avatar)(({ theme }) => ({
    margin: "0 auto",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: 64,
    height: 64,
    marginBottom: theme.spacing(2),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
}));

const StepFlow = () => {
    return (
        <StepContainer>
            <Grid container justifyContent="center" >
                <Grid
                    container
                    spacing={6}
                    justifyContent="center"
                    display="flex"
                    flexDirection="row"
                    justifyItems="center"
                    alignItems="center"
                    maxWidth="60%"
                >
                    {steps.map((step) => (
                        <Grid item key={step.id} xs={12} sm={6} md={4} display="flex" flexDirection="column" alignItems="center">
                            <StepCard>
                                <StepIcon>{step.icon}</StepIcon>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color="primary"
                                    gutterBottom
                                >
                                    {step.id}. Adım
                                </Typography>
                                <Typography
                                    variant="h5"
                                    gutterBottom
                                    sx={{ fontWeight: 600 }}
                                >
                                    {step.title}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="text.secondary"
                                    sx={{ lineHeight: 1.8 }}
                                >
                                    {step.description}
                                </Typography>
                            </StepCard>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </StepContainer>
    );
};

export default StepFlow;
